module.exports = __webpack_public_path__ + "img/nail-polish.4376b6f0.svg";